<ng-container *ngIf="vm$ | async as vm">
  <ng-container *ngIf="selectedPageVersionId$ | async as selectedPageVersionId">
    <div class="container-fluid mt-3 mb-3 page form-field-400-container">
      <div class="row align-items-end title-row">
        <div class="col-12 title-column">
          <h1 class="page-title" data-testid="page-edit-screen-title-english">
            {{ vm.internalName }}
            <ng-container *ngIf="!pageType.isLanding">
              <ng-container *ngIf="accesses.screen.pageDetailScreen.viewPageDetails">
                <svg-icon
                  key="eye"
                  size="lg"
                  class="title-icon inline-icon"
                  *ngIf="readonly$ | async; else editMetaAction"
                  (click)="onShowMetaClick(vm)"
                ></svg-icon>
              </ng-container>
            </ng-container>
          </h1>
          <ng-template #editMetaAction>
            <svg-icon
              *ngIf="!pageType.isLanding && accesses.screen.pageDetailScreen.edit"
              size="lg"
              key="edit"
              class="title-icon inline-icon"
              (click)="onEditMetaClick(vm)"
            ></svg-icon>
          </ng-template>
        </div>
        <div class="col-12 d-flex justify-content-end">
          <div class="select-wrapper" *ngIf="accesses.screen.pageDetailScreen.selectorBetweenPageVersions">
            <mat-form-field>
              <mat-select
                [ngModel]="selectedPageVersionId"
                (selectionChange)="onPageVersionSelect($event)"
                data-testid="page-edit-screen-page-version-select"
              >
                <mat-option *ngIf="vm.publishedPageVersionId" [value]="vm.publishedPageVersionId" data-testid="page-version-option-live">
                  Live
                </mat-option>
                <mat-option *ngIf="vm.draftPageVersionId" [value]="vm.draftPageVersionId" data-testid="page-version-option-draft">
                  Draft (unpublished)
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="row flex-column">
        <form *ngIf="!isAppLandingPageEditor" class="table-controls" [formGroup]="trayListFiltersForm">
          <div class="country-select-container mr-4" *ngIf="!isRedeemPageEditor && accesses.screen.pageDetailScreen.countryFilter">
            <label for="country"><p>Country:</p></label>
            <form>
              <osn-cxb-multi-select
                *ngIf="countries$ | async as countryOptions"
                [formControl]="trayListFiltersFormControls.countries"
                [options]="countryOptions"
                filterPlaceholderLabel="Filter in countries..."
                filterNoEntriesFoundLabel="No country found"
                [emitEntireOption]="true"
                [data-testid]="'page-edit-screen-country-filter-select'"
              ></osn-cxb-multi-select>
            </form>
          </div>

          <!-- AXB-696 HIDE THE USER SEGMENTS update: CXBMERGE PUT THE USER SEGMENT SELECTORS BACK -->
          <div class="segment-select-container" *ngIf="!isRedeemPageEditor">
            <label for="segment"><p>Segment:</p></label>
            <form>
              <osn-cxb-multi-select
                *ngIf="userSegments$ | async as userSegmentOptions"
                [formControl]="trayListFiltersFormControls.userSegments"
                [options]="userSegmentOptions"
                filterPlaceholderLabel="Filter in user segments..."
                filterNoEntriesFoundLabel="No user segment found"
                [emitEntireOption]="true"
                [data-testid]="'page-edit-screen-user-segment-filter-select'"
              ></osn-cxb-multi-select>
            </form>
          </div>
          <ng-container *ngIf="accesses.screen.pageDetailScreen.addTray">
            <button
              *ngIf="!(readonly$ | async)"
              class="secondary ml-3"
              (click)="onAddTrayClick(selectedPageVersionId)"
              data-testid="page-edit-add-tray-button"
            >
              <svg-icon key="plus-bold" size="md" class="mr-2"></svg-icon>
              Add tray
            </button>
          </ng-container>
        </form>
        <!-- for <osn-cxb-tray-list> -->
        <!-- [showUserSegments]="!isRedeemPageEditor" -->
        <!-- TODO:AB AXB-696 HIDE THE USER SEGMENTS (the above is the old value, this is the new ->) [showUserSegments]="false" -->
        <osn-cxb-tray-list
          [userSegmentId]="
            trayListFiltersFormControls.userSegments.value.length > 0 &&
            trayListFiltersFormControls.userSegments.value.length < userSegments.length
              ? trayListFiltersFormControls.userSegments.value
              : false
          "
          [countryId]="
            trayListFiltersFormControls.countries.value.length > 0 && trayListFiltersFormControls.countries.value.length < countries.length
              ? trayListFiltersFormControls.countries.value
              : false
          "
          [pageType]="pageType"
          [pageId]="vm.pageId"
          [pageVersionId]="selectedPageVersionId"
          [vm]="vm.trays"
          [readonly]="readonly$ | async"
          [showCountries]="!isRedeemPageEditor"
          [showUserSegments]="!isRedeemPageEditor"
          [showContentSource]="showContentSource"
          [showScheduling]="!isRedeemPageEditor && !isAppLandingPageEditor"
          [showLayout]="!isAppLandingPageEditor"
          [showTrayType]="!isAppLandingPageEditor"
          [showPlatformType]="showPlatformTargeting"
        ></osn-cxb-tray-list>
      </div>
      <osn-cxb-tray-alert-message *ngIf="isErrorContainerNeedToDisplay$ | async"></osn-cxb-tray-alert-message>
      <div class="row align-items-center">
        <div class="col-6">
          <ng-container *ngIf="readonly$ | async; else deleteDraftAction">
            <ng-container *ngIf="accesses.screen.pageDetailScreen.unpublishThePage">
              <div
                *ngIf="!pageType.isLanding"
                class="d-flex align-items-center text-normal-bold delete-btn"
                (click)="onUnpublishPageClick(vm.pageId)"
                data-testid="page-edit-unpublish-page-button"
              >
                Unpublish the page
              </div>
            </ng-container>
          </ng-container>
          <ng-template #deleteDraftAction>
            <div
              *ngIf="accesses.screen.pageDetailScreen.deleteDraft"
              class="d-flex align-items-center text-normal-bold delete-btn"
              (click)="onDeleteDraftClick(vm.pageId)"
              data-testid="page-edit-delete-draft-button"
            >
              <svg-icon key="trash" size="md"></svg-icon>
              <span>Delete draft</span>
            </div>
          </ng-template>
        </div>
        <div class="col-18 d-flex justify-content-end actions">
          <ng-container *ngIf="readonly$ | async; else editActions">
            <button
              *ngIf="vm.draftPageVersionId && accesses.screen.pageDetailScreen.backToDraft"
              class="secondary"
              (click)="onBackToDraftClick(vm.draftPageVersionId)"
              data-testid="page-edit-back-to-draft-button"
            >
              Back to draft
            </button>
            <button
              *ngIf="!vm.draftPageVersionId && accesses.screen.pageDetailScreen.createDraft"
              (click)="onCreateDraft(vm.pageId)"
              data-testid="page-edit-create-draft-button"
            >
              Create draft
            </button>
          </ng-container>
          <ng-template #editActions>
            <button
              *ngIf="accesses.screen.pageDetailScreen.finishEditing"
              class="secondary"
              (click)="onFinishEditClick()"
              data-testid="page-edit-finish-editing-button"
            >
              Finish editing
            </button>
            <button
              *ngIf="accesses.screen.pageDetailScreen.publishPage"
              (click)="onPublishClick(vm.pageId, vm.titleEnglish)"
              [disabled]="(isPublishButtonShouldBeDisabled$ | async)"
              data-testid="page-edit-publish-page-button"
            >
              Publish page
            </button>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
